import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ClipboardList, Loader2, ArrowRight } from 'lucide-react';
import { moduleApi } from '../../lib/api';

interface MySurvey {
    id: string;
    token: string;
    status: 'pending' | 'responded' | 'completed';
    sent_at: string;
    responded_at: string | null;
    template_name: string;
}

const STATUS_LABELS: Record<string, { label: string; cls: string }> = {
    pending: { label: 'À répondre', cls: 'bg-warning-500/10 text-warning-500 border-warning-500/20' },
    responded: { label: 'Répondu', cls: 'bg-emerald-500/10 text-emerald-500 border-emerald-500/20' },
    completed: { label: 'Répondu', cls: 'bg-emerald-500/10 text-emerald-500 border-emerald-500/20' },
};

export const EmployeeSurveys: React.FC = () => {
    const navigate = useNavigate();
    const [surveys, setSurveys] = useState<MySurvey[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        moduleApi.getMySurveys().then((d: any) => setSurveys(Array.isArray(d) ? d : [])).catch(() => setSurveys([])).finally(() => setLoading(false));
    }, []);

    return (
        <div className="space-y-6">
            <header>
                <h1 className="text-3xl font-bold tracking-tight text-content flex items-center gap-2"><ClipboardList size={24} /> Sondages</h1>
                <p className="text-content-muted mt-1">Les sondages envoyés par votre établissement.</p>
            </header>

            {loading ? (
                <div className="flex justify-center py-16"><Loader2 className="animate-spin text-content-muted" size={24} /></div>
            ) : surveys.length === 0 ? (
                <div className="text-center py-16 border border-dashed border-border rounded-2xl">
                    <ClipboardList size={28} className="mx-auto mb-2 text-content-muted opacity-40" />
                    <p className="text-content-muted text-sm">Aucun sondage pour l'instant.</p>
                </div>
            ) : (
                <div className="max-w-2xl space-y-2">
                    {surveys.map((s) => {
                        const status = STATUS_LABELS[s.status] || STATUS_LABELS.pending;
                        return (
                            <button key={s.id} onClick={() => navigate(`/documentation/${s.token}`)}
                                className="w-full flex items-center gap-4 p-4 rounded-2xl bg-surface-soft border border-border hover:border-brand-500 transition-all text-left">
                                <div className="flex-1 min-w-0">
                                    <p className="font-bold text-content text-sm">{s.template_name}</p>
                                    <p className="text-[11px] text-content-muted mt-0.5">Envoyé le {new Date(s.sent_at).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
                                </div>
                                <span className={`shrink-0 text-[10px] font-black uppercase px-2 py-1 rounded-lg border ${status.cls}`}>{status.label}</span>
                                <ArrowRight size={16} className="text-content-muted shrink-0" />
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default EmployeeSurveys;
